module.exports = __webpack_public_path__ + "static/HUB1-1f26544fd699b53b2ebcc7093869ea44.png";